module.exports = __webpack_public_path__ + "static/media/users.a487b17a.svg";